var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.638 13.3602C15.106 12.5862 15.322 11.8302 15.34 10.7682C15.34 8.03224 13.432 5.87224 10.606 5.87224C7.78 5.87224 5.872 8.03224 5.872 10.7682C5.872 13.4862 7.78 15.6462 10.606 15.6462C11.938 15.6282 12.604 15.3222 13.378 14.7462L11.668 12.9282L13.036 11.6322L14.638 13.3602ZM4 10.7682C4 7.04224 6.718 4.00024 10.606 4.00024C14.494 4.00024 17.194 7.04224 17.194 10.7682C17.176 12.3162 16.744 13.5942 15.952 14.7642L17.374 16.2582L16.042 17.5542L14.674 16.0782C13.54 17.0142 12.46 17.5182 10.606 17.5182C6.718 17.5182 4 14.4762 4 10.7682Z",
    fill: "#9F6BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOn);
export default __webpack_public_path__ + "static/media/question_on.304fcf7d90715e4bf605fb65f5c2db6c.svg";
export { ForwardRef as ReactComponent };